import React from 'react';
import {
  LineChart as ReLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface DataPoint {
  [key: string]: string | number;
}

interface LineChartProps {
  data: DataPoint[];
  xKey: string;
  yKey: string;
  color?: string;
  yLabel?: string;
  unit?: string;
  yDomain?: [number | 'auto', number | 'auto'];
  height?: number;
}

export default function LineChart({
  data,
  xKey,
  yKey,
  color = '#2472C8',
  yLabel,
  unit = '',
  yDomain,
  height = 220,
}: LineChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-text-tertiary text-sm">
        No data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <ReLineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#EEEEEE" vertical={false} />
        <XAxis
          dataKey={xKey}
          tick={{ fontSize: 11, fill: '#999999' }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 11, fill: '#999999' }}
          axisLine={false}
          tickLine={false}
          domain={yDomain}
          label={yLabel ? { value: yLabel, angle: -90, position: 'insideLeft', offset: 10, style: { fontSize: 11, fill: '#999999' } } : undefined}
        />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #DDDDDD' }}
          formatter={(val: unknown) => [`${val}${unit}`]}
        />
        <Line
          type="monotone"
          dataKey={yKey}
          stroke={color}
          strokeWidth={2}
          dot={{ r: 3, fill: color }}
          activeDot={{ r: 5 }}
        />
      </ReLineChart>
    </ResponsiveContainer>
  );
}
